import { Component } from '@angular/core';

@Component({
	selector: 'aside-docs',
	styleUrls: ['docs.component.scss'],
	templateUrl: 'docs.component.html',
})
export class AsideDocsComponent {}
